// import React, { useEffect, useState } from "react";
// import css from "./videoView.module.css";
// import YouTube from "react-youtube";
// import transliterate from "../../function/transliterate";

// const YouBinIntr = ({ windowDimensions, data }) => {
//   const [recommendedVideos, setRecommendedVideos] = useState([]);

//   useEffect(() => {
//     // Перевірка, чи data визначена і є масивом
//     if (!data || !Array.isArray(data)) {
//       console.error("Data is undefined or not an array");
//       return;
//     }

//     // Отримуємо масиви з localStorage
//     const likedProducts =
//       JSON.parse(localStorage.getItem("likedProducts")) || [];
//     const visitedProducts =
//       JSON.parse(localStorage.getItem("visitedProducts")) || [];

//     // Створюємо новий масив, що містить всі елементи з likedProducts
//     const combinedProducts = [...likedProducts];

//     // Додаємо до масиву тільки ті елементи з visitedProducts, яких немає в likedProducts
//     visitedProducts.forEach((item) => {
//       const isDuplicate = likedProducts.some(
//         (likedItem) => likedItem.uid === item.uid,
//       );
//       if (!isDuplicate) {
//         combinedProducts.push(item);
//       }
//     });

//     // Відбираємо відео з масиву data, які відповідають товарам із об'єднаного масиву
//     const selectedVideos = data.filter((video) =>
//       combinedProducts.some((product) => product === video.book_uid),
//     );

//     setRecommendedVideos(selectedVideos);
//   }, [data]);

//   return (
//     <div className={css.smallVideoWrap}>
//       <h1 className={css.smallWrapH1}>Вам буде цікаво</h1>
//       <div className={css.smallvidelListWrap}>
//         {recommendedVideos.length > 0 ? (
//           recommendedVideos.map((video, index) => (
//             <div key={index} className={css.smalVideoPro}>
//               <YouTube
//                 videoId={video.videoId}
//                 opts={{
//                   width: windowDimensions ? "376px" : "290px",
//                   height: windowDimensions ? "224px" : "200px",
//                 }}
//               />
//               <p className={css.videoName}>{video.videoName}</p>
//             </div>
//           ))
//         ) : (
//           <p>Немає рекомендованих відео.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default YouBinIntr;
import { useMemo } from "react";
import YouTube from "react-youtube";

import css from "./videoView.module.css";

const getProductId = (product) => {
  if (typeof product === "string") {
    return product;
  }

  return product?.uid || product?.id || product?.productId || "";
};

const getVideoBookId = (video) => {
  return (
    video?.book_uid || video?.bookUid || video?.bookId || video?.productId || ""
  );
};

const readLocalStorageArray = (key) => {
  try {
    const value = JSON.parse(localStorage.getItem(key));
    return Array.isArray(value) ? value : [];
  } catch (error) {
    console.error(`Не вдалося прочитати ${key}:`, error);
    return [];
  }
};

const YouBinIntr = ({ data = [] }) => {
  const recommendedVideos = useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }

    const likedProducts = readLocalStorageArray("likedProducts");
    const visitedProducts = readLocalStorageArray("visitedProducts");

    const productIds = new Set(
      [...likedProducts, ...visitedProducts].map(getProductId).filter(Boolean),
    );

    if (productIds.size === 0) {
      return [];
    }

    const usedVideoIds = new Set();

    return data.filter((video) => {
      const videoBookId = getVideoBookId(video);
      const videoUniqueId = video.id || video.uid || video.videoId;

      if (!productIds.has(videoBookId) || usedVideoIds.has(videoUniqueId)) {
        return false;
      }

      usedVideoIds.add(videoUniqueId);
      return true;
    });
  }, [data]);

  return (
    <section className={css.smallVideoWrap}>
      <h2 className={css.smallWrapH1}>Вам буде цікаво</h2>

      {recommendedVideos.length > 0 ? (
        <div className={css.smallvidelListWrap}>
          {recommendedVideos.map((video) => (
            <article
              key={video.id || video.uid || video.videoId}
              className={css.smalVideoPro}
            >
              <div className={css.smallVideoPlayer}>
                <YouTube
                  videoId={video.videoId}
                  className={css.smallYoutube}
                  iframeClassName={css.youtubeIframe}
                  opts={{
                    width: "100%",
                    height: "100%",
                    playerVars: {
                      rel: 0,
                    },
                  }}
                />
              </div>

              <p className={css.videoName}>{video.videoName}</p>
            </article>
          ))}
        </div>
      ) : (
        <p className={css.noRecommendedVideos}>Немає рекомендованих відео.</p>
      )}
    </section>
  );
};

export default YouBinIntr;
